import { BetTypeContentProps } from '../bet-type-content';
import { OddsButton } from '@/components/widgets/odds-button';
import { SportMatchModel } from '@nf/types/odds';
import { useAccountInfo } from '@/hooks/query/account';
import { useTranslations } from 'next-intl';
import { BetChoices } from '@/types/bet-type-settings';
import { useAuthToken } from '@/store/auth';
import { useGetBetTypeSetting } from '@/hooks';

export const BetTypeScoreBox = ({ matchModel, betTypeArray }: BetTypeContentProps) => {
	const getBetTypeSetting = useGetBetTypeSetting();
	const t = useTranslations('General');
	const authToken = useAuthToken();
	const market = betTypeArray[0];
	const betTypeId = market.BetTypeId;
	const hdp1 = market.Line;
	const hdp2 = market.hdp2 ?? 0;
	const contentList: JSX.Element[] = [];;
	const betTypeSetting = getBetTypeSetting(market.BetTypeId, matchModel.GameID);
	const startCount = betTypeId == 468 ? 0 : (hdp2 - 1);
	const caculateTime = betTypeId == 468 ? 1 : -1;
	const settingList: Array<BetChoices[]> = [];
	const betInfo: string[][] = [[], []];
	const { user } = useAccountInfo();
	let srcOddsInfo: Array<string> = [];

	const GetSelectionText = (isAway: boolean, line: number, index: number, count: number) => {
		let key: string = '';

		const key468 = {
			'win1': 'lbl_WinByXGoalOrMore',
			'win1s': 'lbl_WinByXGoalsOrMore',
			'win2': 'lbl_WinByXGoal',
			'win2s': 'lbl_WinByXGoals',
			'los1': 'lbl_LoseByXGoalOrMore',
			'los1s': 'lbl_LoseByXGoalsOrMore',
			'los2': 'lbl_LoseByXGoal',
			'los2s': 'lbl_LoseByXGoals'
		}

		const key469 = {
			'less': 'lbl_TotalGoalXOrLess',
			'lesss': 'lbl_TotalGoalsXOrLess',
			'more': 'lbl_TotalGoalsXOrMore',
			'Goal': 'lbl_TotalGoalX',
			'Goals': 'lbl_TotalGoalsX',
		}


		const ext = Math.abs(line) > 1 ? 's' : '';

		if (betTypeId == 468) {
			if (line == 0) {
				key = 'lbl_draw';
			} else {
				if (line > 0) {
					if (index == 0) {
						key = !isAway ? key468['win1' + ext as keyof typeof key468] : key468['los1' + ext as keyof typeof key468];
					} else {
						key = !isAway ? key468['win2' + ext as keyof typeof key468] : key468['los2' + ext as keyof typeof key468];
					}
				} else {
					if (index == (count - 1)) {
						key = !isAway ? key468['los1' + ext as keyof typeof key468] : key468['win1' + ext as keyof typeof key468];
					} else {
						key = !isAway ? key468['los2' + ext as keyof typeof key468] : key468['win2' + ext as keyof typeof key468];
					}
				}
			}
		} else {
			if (line == 0) {
				key = key469['Goal' + ext as keyof typeof key469];
			} else {

				if (index == 0) {
					key = key469['less' + ext as keyof typeof key469];
				} else if (index == count - 1) {
					key = key469['more'];
				} else {
					key = key469['Goal' + ext as keyof typeof key469];
				}
			}
		}

		return t.raw(key).replace('{0}', Math.abs(line).toString());;
	}


	const homeSetting = betTypeSetting.betChoices.filter((choice) => (choice.betTeam === 'H' || choice.betTeam === 'O'));
	const awaySetting = betTypeSetting.betChoices.filter((choice) => (choice.betTeam === 'A' || choice.betTeam === 'U'));
	settingList.push(homeSetting);
	settingList.push(awaySetting);
	settingList.forEach((setting, index) => {
		srcOddsInfo = [];
		let pStartCount = startCount;
		const tddiv: JSX.Element[] = [];
		let line = betTypeId == 468 ? hdp1 : (hdp1 - hdp2 + 1);
		const title = betTypeId == 468 ? (index == 0 ? t('lbl_home') : t('lbl_away')) : (index == 0 ? `${t('lbl_Equal')}/${t('lbl_over')}` : `${t('lbl_Equal')}/${t('lbl_under')}`);
		const priceArray = [];
		for (let j = 0; j < hdp2; j++) {
			const selection = market.Selections[setting[pStartCount].label];
			const price = selection.Price.toFixed(2);
			betInfo[index].push(`${line}:${price}`);
			priceArray.push(parseFloat(price));
			tddiv.push(
				<div key={`${j}_${selection.SelId}`} className="bettype__item">
					<div className="bettype__text">{GetSelectionText(index !== 0, line, j, hdp2)}</div>
					<div className="bettype__odds">{market.IsCP ? '' : '@' + price}</div>
				</div>
			);
			srcOddsInfo.push(`${line}:${price}`)
			pStartCount = (pStartCount + caculateTime);
			line = (line - caculateTime);
		}
		if (!authToken) {
			if ((betTypeId == 468 && index == 1) || (betTypeId == 469 && index == 0)) {
				tddiv.reverse();
			}
		}

		if (betTypeId == 469) {
			srcOddsInfo.reverse();
		}

		contentList.push(
			<div key={`${index}_${settingList[index][0].label}`} className="bettype__row">
				<div className="bettype__col">
					{tddiv}
				</div>
				<div className="bettype__col bettype__col--odds">
					<OddsButton
						key={`${settingList[index][0].betTeam}`}
						match={matchModel as SportMatchModel}
						market={market}
						homeTeamName={''}
						awayTeamName={''}
						variant="default"
						betTeam={setting[index].betTeam}
						sport={matchModel?.GameID}
						title={title}
						type="OU"
						oddsType={user?.OType}
						accountStatus={user?.ActStatus ?? 0}
						oddsInfo={srcOddsInfo.join(',')}
					/>
				</div>
			</div>
		);
	})

	return (
		<>
			<div className="bettype__content bettype__content--scorebox">
				{
					contentList
				}
			</div>
		</>
	)
}